<div class="payment-odt-btn" [ngClass]="{'docked-btn': config?.docked}">
  <button (click)="openSheet(amountForm)" mat-button>{{config?.label}}</button>
</div>

<ng-template #amountForm>
  <app-payment-otd [InputConfig]="config"></app-payment-otd>
</ng-template>